import { Grid } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import {
  mdiAlertCircleOutline,
  mdiAlertOutline,
  mdiDelete,
  mdiDotsVertical,
} from '@mdi/js';
import Icon from '@mdi/react';
import ActionContainer from 'components/ActionContainer/ActionContainer';
import TextInput from 'components/TextInput/TextInput';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const ProjectCompetencyTypeItem = ({
  competencyType,
  loading,
  hasDuplicateName,
  openCompetencyTypesArray,
  setOpenCompetencyTypesArray,
  onChangeCompetencyType,
  onDeleteCompetencyType,
}) => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  const open = useMemo(
    () => openCompetencyTypesArray.includes(competencyType.id),
    [competencyType.id, openCompetencyTypesArray]
  );

  const trimmedName = competencyType.name?.toString().trim() || '';
  const hasNameError = competencyType.isNew && (!trimmedName || hasDuplicateName);

  const titleIcon = hasNameError ? (
    <Icon
      path={mdiAlertCircleOutline}
      size={1}
      color={theme.palette.error.main}
    />
  ) : competencyType.isNew ? (
    <Icon path={mdiAlertOutline} size={1} color={theme.palette.warning.main} />
  ) : null;

  const handleOpen = () => {
    if (open) {
      setOpenCompetencyTypesArray(
        openCompetencyTypesArray.filter((id) => id !== competencyType.id)
      );
      return;
    }

    setOpenCompetencyTypesArray([
      ...openCompetencyTypesArray,
      competencyType.id,
    ]);
  };

  return (
    <ActionContainer
      title={trimmedName || t('common.add_new')}
      closable
      closableDisabled={hasNameError}
      open={open}
      setOpen={handleOpen}
      color="main"
      popperIcon={<Icon path={mdiDotsVertical} size={1} />}
      popperChildren={<Icon path={mdiDelete} size={1} color="red" />}
      onPopper={() => onDeleteCompetencyType(competencyType.id)}
      titleIcon={titleIcon}
      titleIconAlign="right"
    >
      <Grid item xs={12}>
        <TextInput
          label={t('common.name')}
          fullWidth
          value={competencyType.name || ''}
          onChange={(event) =>
            onChangeCompetencyType(competencyType.id, event.target.value)
          }
          disabled={loading || !competencyType.isNew}
          required={competencyType.isNew}
          error={hasNameError}
          helperText={
            hasDuplicateName ? t('project_dialog.competency_type_duplicate') : ''
          }
        />
      </Grid>
    </ActionContainer>
  );
};

ProjectCompetencyTypeItem.propTypes = {
  competencyType: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  hasDuplicateName: PropTypes.bool,
  openCompetencyTypesArray: PropTypes.array.isRequired,
  setOpenCompetencyTypesArray: PropTypes.func.isRequired,
  onChangeCompetencyType: PropTypes.func.isRequired,
  onDeleteCompetencyType: PropTypes.func.isRequired,
};

ProjectCompetencyTypeItem.defaultProps = {
  loading: false,
  hasDuplicateName: false,
};
